export const FAMILY_CASE_TAXONOMY_CONFIG = {
  id: 'family',
  label: 'Family',
  description: 'Family suits, dissolution, khula, maintenance, dower, dowry articles, custody, guardianship, execution, appeals, and related family proceedings.',
  active: true,
  types: [
    {
      id: 'Family Suit',
      label: 'Family Suit',
      shortLabel: 'Suit',
      description: 'Original family proceedings such as dissolution of marriage, khula, maintenance, dower, dowry articles, restitution of conjugal rights, jactitation of marriage, and related family reliefs.',
      legalBasis: 'Sections 5 (jurisdiction), 7 (institution), 9 (written statement), 10 (pre-trial/reconciliation), 11 (evidence), 12 (conclusion), 17 (CPC/QSO exclusion), 17-A (interim maintenance) of West Pakistan Family Courts Act, 1964; Muslim Family Laws Ordinance, 1961.',
      subtypes: [
        'Dissolution of Marriage',
        'Khula',
        'Maintenance',
        'Past Maintenance',
        'Future Maintenance',
        'Dower',
        'Dowry Articles',
        'Restitution of Conjugal Rights',
        'Jactitation of Marriage',
        'Declaration Regarding Marriage',
        'Recovery of Personal Belongings',
        'Multiple Family Reliefs',
        'Other Family Suit'
      ],
      courtOptions: [
        { id: 'Family Court', label: 'Family Court', description: 'Primary forum for family suits under the Family Courts Act, 1964.' },
        { id: 'Family Court / Civil Judge Exercising Family Jurisdiction', label: 'Family Court / Civil Judge Exercising Family Jurisdiction', description: 'Use where local district setup assigns family matters to a Civil Judge / Judge exercising family jurisdiction.' },
        { id: 'Other / Custom Forum', label: 'Other / Custom Forum', description: 'Use only if local practice, special law, or court assignment differs.' }
      ],
      courtHelper: 'Family suits are generally filed before the Family Court having territorial jurisdiction. Court assignment may vary by district.',
      sideOptions: ['Plaintiff', 'Defendant'],
      documentTabs: [
        'All',
        'Plaint / Suit',
        'Written Statement',
        'Applications',
        'Evidence',
        'Orders & Decrees',
        'Miscellaneous'
      ],
      defaultStages: [
        'Pre-Filing / Case Preparation',
        'Suit / Plaint Drafting',
        'Filing / Institution',
        'Scrutiny / Objections',
        'Summons / Notice to Defendant',
        'Defendant Appearance',
        'Written Statement',
        'Pre-Trial / Reconciliation Proceedings',
        'Interim Maintenance',
        'Issues / Points for Determination',
        'Plaintiff Evidence',
        'Defendant Evidence',
        'Final Arguments',
        'Judgment',
        'Decree',
        'Execution / Appeal',
        'Closed'
      ],
      aiContextHints: 'AI should understand family relief type, marriage relationship, children/minors if relevant, nikahnama, dower, dowry articles, maintenance claim, reconciliation, interim maintenance, evidence, judgment, decree, execution, and appeal.'
    },
    {
      id: 'Guardianship / Custody',
      label: 'Guardianship / Custody',
      shortLabel: 'Custody',
      description: 'Proceedings relating to custody, guardianship, visitation, meeting rights, recovery of minor, and welfare of minors.',
      legalBasis: 'Guardians and Wards Act, 1890. Section 25 West Pakistan Family Courts Act, 1964.',
      subtypes: [
        'Custody of Minor',
        'Guardianship Certificate',
        'Visitation / Meeting Rights',
        'Interim Custody',
        'Recovery of Minor',
        'Modification of Custody Order',
        'Enforcement of Visitation Order',
        'Other Guardianship / Custody Matter'
      ],
      courtOptions: [
        { id: 'Guardian Court / Family Court', label: 'Guardian Court / Family Court', description: 'Primary forum for custody and guardianship matters, depending on local designation and Family Courts Act jurisdiction.' },
        { id: 'District Judge / Guardian Judge', label: 'District Judge / Guardian Judge', description: 'Use where guardianship matters are instituted before or assigned through the District Judge / Guardian Judge according to local practice.' },
        { id: 'Family Court / Civil Judge Exercising Guardian Jurisdiction', label: 'Family Court / Civil Judge Exercising Guardian Jurisdiction', description: 'Use where a Civil Judge or Family Judge is exercising guardian/custody jurisdiction.' },
        { id: 'Other / Custom Forum', label: 'Other / Custom Forum', description: 'Use if local practice or court assignment differs.' }
      ],
      courtHelper: 'Custody and guardianship forum may depend on local court designation. Welfare of the minor remains the controlling consideration.',
      sideOptions: ['Petitioner', 'Respondent', 'Applicant', 'Guardian', 'Opposing Party'],
      documentTabs: [
        'All',
        'Petition',
        'Applications',
        'Minor Documents',
        'Evidence',
        'Orders',
        'Miscellaneous'
      ],
      defaultStages: [
        'Case Preparation / Welfare Assessment',
        'Petition Drafting',
        'Filing',
        'Scrutiny / Objections',
        'Notice to Respondent',
        'Respondent Appearance',
        'Reply / Written Statement',
        'Interim Custody / Visitation',
        'Production / Meeting of Minor',
        'Reconciliation / Settlement Efforts',
        'Evidence',
        'Welfare Assessment / Court Interaction',
        'Arguments',
        'Final Order / Guardian Certificate',
        'Compliance / Visitation Implementation',
        'Modification / Appeal',
        'Closed'
      ],
      aiContextHints: 'AI should understand minor’s name/age, current custody, relationship of parties, welfare factors, education, health, living arrangements, visitation, interim custody, guardian certificate, and prior custody orders.'
    },
    {
      id: 'Family Execution',
      label: 'Family Execution',
      shortLabel: 'Execution',
      description: 'Execution proceedings for enforcement of family court decrees or orders, including maintenance, dower, dowry articles, custody, visitation, and other executable family reliefs.',
      legalBasis: 'Section 13 Family Courts Act, 1964.',
      subtypes: [
        'Execution of Maintenance Decree',
        'Execution of Dower Decree',
        'Execution of Dowry Articles Decree',
        'Execution of Custody Order',
        'Execution of Visitation Order',
        'Execution of Compromise Decree',
        'Execution of Family Court Decree',
        'Other Family Execution'
      ],
      courtOptions: [
        { id: 'Family Court / Executing Family Court', label: 'Family Court / Executing Family Court', description: 'Court for enforcement of family decree/order, usually the Family Court or executing forum.' },
        { id: 'Court Which Passed the Decree', label: 'Court Which Passed the Decree', description: 'Use where decree is executed by the court that passed it or the court assigned execution.' },
        { id: 'Transferee / Assigned Executing Court', label: 'Transferee / Assigned Executing Court', description: 'Use where execution is transferred or assigned.' },
        { id: 'Other / Custom Forum', label: 'Other / Custom Forum', description: 'Use if local practice differs.' }
      ],
      courtHelper: 'Execution forum depends on the court passing the family decree/order and local execution practice.',
      sideOptions: ['Decree Holder', 'Judgment Debtor', 'Applicant', 'Respondent'],
      documentTabs: [
        'All',
        'Execution Petition',
        'Decree / Order',
        'Applications',
        'Process / Recovery',
        'Orders',
        'Miscellaneous'
      ],
      defaultStages: [
        'Decree / Order Review',
        'Calculation / Arrears Preparation',
        'Execution Petition Drafting',
        'Filing',
        'Scrutiny / Objections',
        'Notice to Judgment Debtor',
        'Objections / Reply',
        'Process / Recovery Proceedings',
        'Payment / Compliance / Delivery',
        'Partial Satisfaction',
        'Full Satisfaction / Disposal',
        'Further Remedy',
        'Closed'
      ],
      aiContextHints: 'AI should understand decree holder, judgment debtor, decree date, arrears, maintenance calculation, dower amount, dowry articles, custody/visitation order, compliance, recovery, partial satisfaction, and final disposal.'
    },
    {
      id: 'Family Appeal',
      label: 'Family Appeal',
      shortLabel: 'Appeal',
      description: 'Appeals against family court judgments, decrees, or orders where appeal is maintainable.',
      legalBasis: 'Section 14 Family Courts Act, 1964.',
      subtypes: [
        'Appeal Against Family Decree',
        'Appeal Against Maintenance Decree',
        'Appeal Against Dower Decree',
        'Appeal Against Dowry Articles Decree',
        'Appeal Against Custody Order',
        'Appeal Against Guardianship Order',
        'Appeal Against Interim Order',
        'Other Family Appeal'
      ],
      courtOptions: [
        { id: 'District Court / District Judge', label: 'District Court / District Judge', description: 'Common appellate forum for appeals from Family Court decrees/orders, depending on applicable law and local court structure.' },
        { id: 'High Court', label: 'High Court', description: 'Use where appeal/revision/constitutional remedy lies before the High Court.' },
        { id: 'Other / Custom Forum', label: 'Other / Custom Forum', description: 'Use if special forum or local practice differs.' }
      ],
      courtHelper: 'Family appellate forum and maintainability depend on the nature of decree/order and the Family Courts Act. Please verify before filing.',
      sideOptions: ['Appellant', 'Respondent'],
      documentTabs: [
        'All',
        'Memo of Appeal',
        'Applications',
        'Impugned Judgment / Decree',
        'Record',
        'Orders',
        'Miscellaneous'
      ],
      defaultStages: [
        'Review of Impugned Judgment / Decree',
        'Certified Copies Awaited',
        'Memo of Appeal Drafting',
        'Filing of Appeal',
        'Objections / Scrutiny',
        'Admission / Preliminary Hearing',
        'Notice to Respondent',
        'Record Summoned / Received',
        'Stay / Suspension Application',
        'Arguments',
        'Judgment / Final Order',
        'Further Remedy',
        'Closed'
      ],
      aiContextHints: 'AI should understand impugned family decree/order, grounds of appeal, limitation, maintenance/dower/dowry/custody context, certified copies, stay/suspension, and prayer.'
    },
    {
      id: 'Family Miscellaneous Application',
      label: 'Family Miscellaneous Application',
      shortLabel: 'Application',
      description: 'Connected or standalone family applications filed during family suits, custody matters, appeals, or executions.',
      legalBasis: 'Section 17-A (Interim Maintenance), 25-A (Transfer), 25-B (Stay), Family Courts Act, 1964.',
      subtypes: [
        'Interim Maintenance Application',
        'Application for Interim Custody',
        'Application for Visitation / Meeting Rights',
        'Application for Striking Off Defence',
        'Application for Restoration',
        'Application for Setting Aside Ex Parte Proceedings',
        'Application for Amendment',
        'Application for Summoning Record',
        'Application for Production of Documents',
        'Application for Transfer',
        'Application for Stay of Proceedings',
        'Application for Early Hearing',
        'Other Family Application'
      ],
      courtOptions: [
        { id: 'Same Family Court Where Case Is Pending', label: 'Same Family Court Where Case Is Pending', description: 'For applications connected with a pending family suit, custody matter, execution, or other family proceeding.' },
        { id: 'District Court / District Judge', label: 'District Court / District Judge', description: 'For transfer, stay, appeal-connected, or supervisory family matters where applicable.' },
        { id: 'High Court', label: 'High Court', description: 'For constitutional/supervisory context or stay/transfer where applicable.' },
        { id: 'Other / Custom Forum', label: 'Other / Custom Forum', description: 'Use if local practice or forum differs.' }
      ],
      courtHelper: 'Application forum depends on the pending family proceeding and the relief requested.',
      sideOptions: ['Applicant', 'Respondent', 'Plaintiff', 'Defendant'],
      documentTabs: [
        'All',
        'Application',
        'Reply / Objections',
        'Supporting Documents',
        'Orders',
        'Miscellaneous'
      ],
      defaultStages: [
        'Application Preparation',
        'Filing',
        'Scrutiny / Objections',
        'Notice to Respondent',
        'Reply / Objections',
        'Arguments',
        'Order',
        'Compliance / Further Proceedings',
        'Closed'
      ],
      aiContextHints: 'AI should understand application subtype, pending case type, relief requested, urgency, parties, minor/maintenance context if relevant, supporting documents, and order sought.'
    },
    {
      id: 'Other Family Matter',
      label: 'Other Family Matter',
      shortLabel: 'Other Family',
      description: 'Use this for family matters that do not fit the available family case types.',
      subtypes: [
        'Custom Family Matter',
        'Other'
      ],
      courtOptions: [
        { id: 'Family Court', label: 'Family Court', description: '' },
        { id: 'Guardian Court / Family Court', label: 'Guardian Court / Family Court', description: '' },
        { id: 'District Court / District Judge', label: 'District Court / District Judge', description: '' },
        { id: 'High Court', label: 'High Court', description: '' },
        { id: 'Other / Custom Forum', label: 'Other / Custom Forum', description: '' }
      ],
      sideOptions: ['Party A', 'Party B', 'Applicant', 'Respondent'],
      documentTabs: [
        'All',
        'Documents',
        'Applications',
        'Orders',
        'Miscellaneous'
      ],
      defaultStages: [
        'Case Preparation',
        'Filing / Institution',
        'Notice / Summons',
        'Reply / Response',
        'Reconciliation / Proceedings',
        'Evidence / Hearing',
        'Arguments',
        'Order / Judgment',
        'Compliance / Further Remedy',
        'Closed'
      ],
      aiContextHints: 'AI should rely on user-provided description, uploaded documents, forum, relationship details, minor details if relevant, and selected relief.'
    }
  ]
};

export const normalizeFamilyCaseClassification = (existingCase: any) => {
  if (existingCase.caseCategory) {
    return existingCase;
  }

  const legacyType = existingCase.matterType || existingCase.caseTypeName || existingCase.caseType || '';
  const legacyTypeLower = legacyType.toLowerCase();

  const caseTypeMap: Record<string, { type: string; subtype?: string }> = {
    'family suit': { type: 'Family Suit' },
    'suit for dissolution of marriage': { type: 'Family Suit', subtype: 'Dissolution of Marriage' },
    'dissolution of marriage': { type: 'Family Suit', subtype: 'Dissolution of Marriage' },
    'khula': { type: 'Family Suit', subtype: 'Khula' },
    'maintenance': { type: 'Family Suit', subtype: 'Maintenance' },
    'suit for maintenance': { type: 'Family Suit', subtype: 'Maintenance' },
    'past maintenance': { type: 'Family Suit', subtype: 'Past Maintenance' },
    'future maintenance': { type: 'Family Suit', subtype: 'Future Maintenance' },
    'dower': { type: 'Family Suit', subtype: 'Dower' },
    'suit for dower': { type: 'Family Suit', subtype: 'Dower' },
    'dowry articles': { type: 'Family Suit', subtype: 'Dowry Articles' },
    'suit for dowry articles': { type: 'Family Suit', subtype: 'Dowry Articles' },
    'restitution of conjugal rights': { type: 'Family Suit', subtype: 'Restitution of Conjugal Rights' },
    'jactitation of marriage': { type: 'Family Suit', subtype: 'Jactitation of Marriage' },

    'custody': { type: 'Guardianship / Custody', subtype: 'Custody of Minor' },
    'custody of minor': { type: 'Guardianship / Custody', subtype: 'Custody of Minor' },
    'guardianship': { type: 'Guardianship / Custody', subtype: 'Guardianship Certificate' },
    'guardianship certificate': { type: 'Guardianship / Custody', subtype: 'Guardianship Certificate' },
    'visitation rights': { type: 'Guardianship / Custody', subtype: 'Visitation / Meeting Rights' },
    'meeting rights': { type: 'Guardianship / Custody', subtype: 'Visitation / Meeting Rights' },
    'recovery of minor': { type: 'Guardianship / Custody', subtype: 'Recovery of Minor' },

    'family execution': { type: 'Family Execution' },
    'execution of maintenance decree': { type: 'Family Execution', subtype: 'Execution of Maintenance Decree' },
    'execution of dower decree': { type: 'Family Execution', subtype: 'Execution of Dower Decree' },
    'execution of dowry articles decree': { type: 'Family Execution', subtype: 'Execution of Dowry Articles Decree' },
    'execution of custody order': { type: 'Family Execution', subtype: 'Execution of Custody Order' },

    'family appeal': { type: 'Family Appeal' },
    'appeal against family decree': { type: 'Family Appeal', subtype: 'Appeal Against Family Decree' },
    'appeal against maintenance decree': { type: 'Family Appeal', subtype: 'Appeal Against Maintenance Decree' },
    'appeal against custody order': { type: 'Family Appeal', subtype: 'Appeal Against Custody Order' },
    'appeal against guardianship order': { type: 'Family Appeal', subtype: 'Appeal Against Guardianship Order' },

    'family miscellaneous application': { type: 'Family Miscellaneous Application' },
    'interim maintenance application': { type: 'Family Miscellaneous Application', subtype: 'Interim Maintenance Application' },
    'interim custody application': { type: 'Family Miscellaneous Application', subtype: 'Application for Interim Custody' },
    'restoration application': { type: 'Family Miscellaneous Application', subtype: 'Application for Restoration' },
    'setting aside ex parte proceedings': { type: 'Family Miscellaneous Application', subtype: 'Application for Setting Aside Ex Parte Proceedings' },
    'early hearing application': { type: 'Family Miscellaneous Application', subtype: 'Application for Early Hearing' }
  };

  const mapped = caseTypeMap[legacyTypeLower];
  
  if (mapped) {
    return {
      ...existingCase,
      caseCategory: 'Family',
      caseType: mapped.type,
      ...(mapped.subtype && { caseSubtype: mapped.subtype }),
      legacyCaseType: legacyType
    };
  }

  // Check if it should be Family but not in map. For example "Family" 
  if (legacyTypeLower.includes('family')) {
     return {
         ...existingCase,
         caseCategory: 'Family',
         caseType: legacyType,
         legacyCaseType: legacyType
     };
  }

  return existingCase;
};
